<div>
    <button
        mat-icon-button
        (click)="isToDoPanelOpen = !isToDoPanelOpen"
        type="button"
        cdkOverlayOrigin
        #triggerToDoPanel="cdkOverlayOrigin"
    >
        <mat-icon>check_circle</mat-icon>
    </button>
    <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="triggerToDoPanel"
        [cdkConnectedOverlayOpen]="isToDoPanelOpen"
        [cdkConnectedOverlayHasBackdrop]="true"
        (backdropClick)="isToDoPanelOpen = false"
    >
        <div class="one-row quick-todo-panel">
            <mat-form-field>
                <mat-label>Liste</mat-label>
                <mat-select [formControl]="listSelectionCtrl">
                    @for (list of todoLists; track list?.id) {
                        <mat-option [value]="list">{{ list?.listName }}</mat-option>
                    }
                    <mat-option (click)="$event.stopPropagation(); createNewList()"
                        ><div class="one-row"><mat-icon>add</mat-icon><span>Neue Liste</span></div></mat-option
                    >
                </mat-select>
            </mat-form-field>
            <mat-form-field style="min-width: 300px">
                <mat-label>Todo</mat-label>
                <input
                    matInput
                    type="text"
                    [formControl]="todoCtrl"
                    (keyup.enter)="addTodo()"
                    placeholder="ToDo eintragen"
                />
            </mat-form-field>
        </div>
    </ng-template>
</div>
